import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { useNavigate, Link } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";

export default function PlayerLogin() {
  const nav = useNavigate();
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (mobile.length !== 10) { toast.error("Enter valid 10-digit mobile"); return; }
    if (!password) { toast.error("Enter your password"); return; }
    setLoading(true);
    try {
      const r = await api.post("/players/login", { mobile, password });
      localStorage.setItem("ndpl_player_token", r.data.token);
      toast.success("Welcome back!");
      nav("/player/dashboard");
    } catch (e) { toast.error(e.response?.data?.detail || "Login failed"); }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white grid place-items-center px-6">
      <form onSubmit={submit} className="w-full max-w-md p-8 bg-[#0B132B] border border-white/10 rounded-lg">
        <Link to="/" className="font-display text-3xl block text-center">NDPL <span className="text-[#39FF14]">•</span> LOGIN</Link>
        <div className="text-center text-xs uppercase tracking-[0.3em] text-[#FFD700] mt-2">Player Portal</div>

        <div className="mt-8 space-y-4">
          <label className="block">
            <span className="text-xs uppercase tracking-widest text-white/60">Mobile Number</span>
            <div className="mt-2 flex">
              <span className="px-3 py-3 bg-black/70 border border-white/15 border-r-0 text-white/60 text-sm">+91</span>
              <input data-testid="login-mobile" value={mobile} onChange={(e) => setMobile(e.target.value.replace(/\D/g, "").slice(0, 10))} className="flex-1 bg-black/50 border border-white/15 focus:border-[#39FF14] focus:outline-none px-4 py-3" placeholder="10-digit mobile" />
            </div>
          </label>
          <label className="block">
            <span className="text-xs uppercase tracking-widest text-white/60">Password</span>
            <div className="mt-2 relative">
              <input data-testid="login-password" type={showPw ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-black/50 border border-white/15 focus:border-[#39FF14] focus:outline-none px-4 py-3 pr-11" placeholder="Your password" />
              <button type="button" onClick={() => setShowPw(!showPw)} className="absolute right-3 top-1/2 -translate-y-1/2 text-white/50 hover:text-white">{showPw ? <EyeOff size={16}/> : <Eye size={16}/>}</button>
            </div>
          </label>
          <button data-testid="login-submit" disabled={loading} className="w-full py-3 bg-[#39FF14] text-black font-bold uppercase tracking-widest">{loading ? "..." : "Login"}</button>
          <div className="text-center text-sm text-white/60 mt-4">Not registered? <Link to="/register" className="text-[#39FF14] underline">Register now</Link></div>
        </div>
      </form>
    </div>
  );
}
